import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { GovernedDatasetDto } from "@/shared/dtos/Gateway/governed-dataset-dto.ts";

interface NegotiationState {
	datasetId: string | null;
	isNegotiated: boolean;
}

interface DatasetState {
	newDataset: GovernedDatasetDto | null;
	negotiationState: NegotiationState | null;
}

const initialState: DatasetState = {
	newDataset: null,
	negotiationState: null,
};

const datasetSlice = createSlice({
	name: "dataset",
	initialState,
	reducers: {
		setNewDataset: (state, action: PayloadAction<GovernedDatasetDto>) => {
			state.newDataset = action.payload;
		},
		resetDataset: (state) => {
			state.newDataset = null;
		},
		setNegotiationState: (state, action: PayloadAction<NegotiationState>) => {
			state.negotiationState = action.payload;
		},
		resetNegotiationState: (state) => {
			state.negotiationState = null;
		},
	},
});

export default datasetSlice;
